import { render, staticRenderFns } from "./SalesRecord.vue?vue&type=template&id=638a5346&scoped=true"
import script from "./SalesRecord.vue?vue&type=script&lang=js"
export * from "./SalesRecord.vue?vue&type=script&lang=js"
import style0 from "./SalesRecord.vue?vue&type=style&index=0&id=638a5346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638a5346",
  null
  
)

export default component.exports